import styled from "styled-components";
import { LogoWhite } from "../../../assets/svg/Svgs";
import { APP_NAME } from "../../../constants/constants";
import { formatWalletNumber, getDisplayName } from "../../../utils/helpers";
import { useAuth } from "../../context/AuthContext";
import { CopyTextField } from "../../elements/Elements";

export const WalletCard = () => {
  const { user } = useAuth();
  const { wallet } = user || {};
  const { wallet_number = "Wallet Number", currency = "UGX" } = wallet || {};
  return (
    <Wrapper className="flexCenter">
      <CardWrapper className="bgGradient r15 white flexColumn hidden">
        <div data-aos="zoom-out" data-aos-duration="2000">
          <img id="overlay" src={LogoWhite} width={200} alt="logo" />
        </div>
        <div className="flexSpaceCenter">
          <div className="flexNullCenter gap10">
            <img src={LogoWhite} width={18} alt="logo" />
            <div className=" font13">{APP_NAME}</div>
          </div>

          <div className="">{currency}</div>
        </div>
        <div className="flexGrow" />
        <div className="mb5 semiBold font16 monospace">
          <CopyTextField>{formatWalletNumber(wallet_number)}</CopyTextField>
        </div>
        <div className="font13 light">{getDisplayName(user)}</div>
      </CardWrapper>
    </Wrapper>
  );
};

const CardWrapper = styled.div`
  padding: 20px;
  height: 140px;
  position: relative;
  width: 280px;
  max-width: 280px;

  @media (max-width: 960px) {
    width: 100%;
  }

  #overlay {
    position: absolute;
    opacity: 0.1;
    right: -40px;
  }
`;

const Wrapper = styled.div`
  @media (max-width: 960px) {
  }
`;
